module.exports = __webpack_public_path__ + "static/media/z.754b1a11.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/z.mp3
// module id = 115
// module chunks = 0